export { default } from './Bios'
